import { Layout } from "antd";
import { Content } from "antd/es/layout/layout";
import styled from "styled-components";

// 布局总体
export const Container = styled(Layout)`
  width: 100vw;
  height: 100vh;
  background-size: cover;
  background-repeat: no-repeat;
`;
// 右侧内容容器
export const RightContainer = styled(Layout)`
  background: #f5f7fa;
  flex: 1;
  overflow: hidden;
`;
// 左侧内容容器
export const LContent = styled(Content)`
  flex: 1;
`;
// 内容容器
export const Main = styled.div`
  width: 100%;
  height: 100%;
  background: rgba(255, 255, 255, 0.1);
  opacity: 1;
  border: 1px solid rgba(254, 255, 254, 0.1);
  margin: 0 !important;
  padding: 15px;
  overflow: auto;
`;
